'use client';

import { RarityText } from '../RarityText';

interface DetailSubtitleProps {
  itemType: string;
  tier: string;
}

export const DetailSubtitle: React.FC<DetailSubtitleProps> = ({
  itemType,
  tier,
}: DetailSubtitleProps) => {
  return (
    <RarityText
      weight='medium'
      rarity={tier}
    >
      {tier + ' ' + itemType}
    </RarityText>
  );
};
